import { PageLayout } from "@/components/PageLayout";
import { PageHero, SectionCTA } from "@/components/PageHero";
import { Gallery as GallerySection } from "@/components/Gallery";

const Gallery = () => (
  <PageLayout testId="gallery-page">
    <PageHero
      eyebrow="The Eats Gallery"
      title="What's"
      accent="Cookin'"
      breadcrumb="Gallery"
      subtitle="A look at the food that built our reputation. Tap the menu when you're ready to put one of these in your hands."
      bg="/assets/photos/IMG_3967.jpeg"
    />
    <GallerySection />
    <section className="bg-[#1A1A1A] border-t border-[#222] py-14">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h3 className="font-heading text-3xl sm:text-4xl text-white mb-6">
          Hungry yet? <span className="text-[#E60000]">Order up.</span>
        </h3>
        <div className="flex flex-wrap justify-center gap-3">
          <SectionCTA to="/menu" label="Browse The Menu" />
          <SectionCTA to="/reviews" label="Read Reviews" />
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Gallery;
